import { useQuery } from '@zenbusiness/application-commons-graphql';

import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import { useLogError } from '#client/hooks/useLogError';
import { BANKING_PREFERRED_ORDER_STATUS } from '#client/queries';

export default function useBankingPreferredOrderStatus({ isSkip = false }) {
  const { businessEntityUuid } = useConstBusinessEntityUuid();
  const { error, data, loading, errors } = useQuery(BANKING_PREFERRED_ORDER_STATUS, {
    variables: {
      input: {
        businessUuid: businessEntityUuid
      }
    },
    skip: !businessEntityUuid || isSkip,
    skipCache: true,
    noThrow: true
  });

  useLogError(errors, error);
  return {
    isCheckingBankingPreferredOrderStatus: loading,
    bankingPreferredOrderStatusError: error,
    hasBankingPreferredOrder: data?.bankingPreferredOrderStatus?.hasOrder
  };
}
